import React from "react";
import { Row, Col } from "react-bootstrap";
import { Map, Marker, Popup, TileLayer } from "react-leaflet";
import "../styles/Location.css";
import "../styles/Contact.css";
import JumboContainer from "./common/JumboContainer";
import ContactForm from "./common/ContactForm";
import Heading from "./common/Heading";
import { useTranslation } from "react-i18next";
import {
  CONTACT_EYEBROW,
  CONTACT_LABEL,
  QUESTION_FORM_SUBTITLE,
  QUESTION_FORM_TITLE,
} from "../data/i18n/contact";

const position = [26.90535299530838, 75.7355078043587];
export default function Contact() {
  const { t } = useTranslation();

  return (
    <JumboContainer id="contact" eyebrow={t(CONTACT_EYEBROW)} title={t(CONTACT_LABEL)}>
      <Row className="justify-content-md-center contact-row">
        <Col xs="12" lg="6" className="mb-4 mb-lg-0">
          <div className="map-card">
            <Map center={position} zoom={12}>
              <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution="|| Freshokartz Kiosk Locations ||"
              />

              <Marker key={"FRESHOKARTZ HQ"} position={position}>
                <Popup>
                  {`
                      Freshokartz Agri products pvt ltd
                      3rd floor, B2/425, Roshan Marg, Chitrakoot, Vaishali Nagar,
                      Jaipur, Rajasthan 302021
                      `}
                  <hr />
                  <a
                    href={"https://maps.app.goo.gl/s7MmY2RfjEbQv5b59"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Show in Google Maps
                  </a>
                </Popup>
              </Marker>
            </Map>
          </div>
        </Col>
        <Col xs="12" lg="6">
          <div className="form-card">
            <Heading
              title={t(QUESTION_FORM_TITLE)}
              subtitle={t(QUESTION_FORM_SUBTITLE)}
            />
            <ContactForm />
          </div>
        </Col>
      </Row>
    </JumboContainer>
  );
}
